<template>
  <div :class="wrapperStyles">
    <div :class="imageStyles" />
  </div>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppFixedImage',
  props: {
    srcUrl: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    imageWidth: {
      type: Number,
      default: null,
    },
    imageHeight: {
      type: Number,
      default: null,
    },
  },
  computed: {
    boundingWidth() {
      return this.imageWidth || this.width
    },
    boundingHeight() {
      return this.imageHeight || this.height
    },
    imageStyles() {
      return css`
        width: ${this.boundingWidth}px !important;
        height: ${this.boundingHeight}px !important;
        background-image: url(${this.srcUrl});
        background-size: 100% 100%;
      `
    },
    wrapperStyles() {
      return css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${this.boundingWidth}px;
        height: ${this.boundingHeight}px;
      `
    },
  },
}
</script>

<style></style>
